
import { Component, Vue } from 'vue-property-decorator'

import { EventLog as EventLogModel } from '../../lib/models/EventLog'

import BacInput from '@/components/BacInput.vue'

@Component({
  components: {
    BacInput
  }
})
export default class EventLog extends Vue {
  events: EventLogModel[] = []

  filter = ''

  mounted () {
    this.loadEvents()
    setInterval(this.loadEvents, 1000)
  }

  async loadEvents () {
    this.events = await EventLogModel.getAll({ params: [this.filter] })
  }
}
